import React, { Component } from 'react'
import { Button } from "reactstrap";
import { storedb } from '../../views/client/storedb'
import { BtnType } from "../../lib/BtnPermissions"

export class ButtonExt extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false
    this.state = {
      BtnPermissionsRoles: storedb().getPermissionsRoles(),
      PreventDoubleClick: false,
    };
  }
  componentWillUnmount() {
    this._isMounted = false
  }
  componentDidMount() {
    this._isMounted = true
  }
  onClick = e => {
    this.setState({PreventDoubleClick: true}, () => {
      this.props.btnClick(e)
    })
    setTimeout(() => {
      if (this._isMounted) {
        this.setState({PreventDoubleClick: false})
      }
    }, 500)
  }
  render() {
    const {
      btnId,
      btnClass,
      btnSize,
      isDisabled,
      btnClick,
      iconClass,
      childClass,
      displayText,
      color,
      permission,
      btnType,
      btnValue,
      btnTitle,
      skipText,
      noMb,
    } = this.props

    const btnState = (isDisabled || this.state.PreventDoubleClick)
    const { BtnPermissionsRoles } = this.state;
    let hasPermission = true;
    if (permission && permission != '') {
      hasPermission = BtnPermissionsRoles.indexOf(permission) > -1 ? true : false;
    } else if (permission === undefined) {
      console.warn(`button [${displayText}] chưa gắn với quyền nào`)
    }

    if (hasPermission) {
      if (btnType == BtnType.ButtonLink) {
        return (
          <a className={btnClass} onClick={() => btnClick()}>
            <i className={`fa ${iconClass}`}></i>&nbsp;{displayText}
          </a>
        )
      } else if (btnType == BtnType.Checkbox) {
        return (
          <div className="form-check">
            <input className={btnClass}
              title={btnTitle}
              onClick={e => btnClick(e)} 
              type="checkbox" 
              id={btnId} 
              value={btnValue} />
            <label className="form-check-label" htmlFor={btnId}>{displayText}</label>
          </div>
        )
      } else {
        return (
          <Button size={btnSize} color={color} disabled={btnState} className={`${noMb ? '' : 'mb-1'} ${btnClass}`} onClick={e => this.onClick(e)}>
            <i className={`fa ${iconClass}`}></i>
            <span className={(skipText == true) ? `d-none d-sm-inline ${childClass}` : `${childClass}`}>&nbsp;{displayText}</span>
          </Button>
        )
      }

    } else {
      return null
    }
  }
}

export default ButtonExt


// WEBPACK FOOTER //
// ./src/views/controls/ButtonExt.js